/*
 * l3art-beacon (26 sep 2026). Telt anoniem dat een bezoeker contact zoekt, en waar hij binnenkwam. Nooit wie.
 *
 *   <script src="https://l3art.nl/b.js" data-bedrijf="<bedrijf_id>" defer></script>
 *
 * Werkt op elk platform (Next.js, WordPress, Shopify, losse HTML): geen framework, geen cookie, geen afhankelijkheid.
 * Telt: klik op tel: (bellen), mailto: (email), wa.me / api.whatsapp.com (whatsapp), en het versturen van een
 * formulier met een e-mail- of telefoonveld (formulier). Zoekvelden en nieuwsbrief-knoppen zonder zo'n veld tellen niet.
 *
 * sessionStorage, geen cookie: eerstepartij, verdwijnt met het tabblad, geen identificatie, met niemand gedeeld.
 * Daardoor valt de teller buiten de toestemmingsplicht en verandert er niets aan een cookiebanner.
 * Voorbeeld en herkomst van de aanpak: klanten/wonderentegelwerken/components/Beacon.tsx (6 sep 2026).
 */
(function () {
  var s = document.currentScript;
  var BEDRIJF = s && s.getAttribute("data-bedrijf");
  if (!BEDRIJF || !/^[a-z0-9-]{2,32}$/.test(BEDRIJF)) return;
  var REST = "https://igxiazraitpysendghds.supabase.co/rest/v1/motor_conversies";
  var KEY = "sb_publishable_kGqGJeVlJpczYeF-ha-Bbg_zsTNlOjw";
  var HOK = "l3_herkomst";

  function herkomst() {
    try {
      var b = sessionStorage.getItem(HOK);
      if (b) return JSON.parse(b);
      var verwijzer = "direct";
      if (document.referrer) {
        try {
          var h = new URL(document.referrer).hostname;
          verwijzer = h === location.hostname ? "direct" : h.replace(/^www\./, "");
        } catch (e) { verwijzer = "onbekend"; }
      }
      var q = new URLSearchParams(location.search);
      var bron = q.get("utm_source"), camp = q.get("utm_campaign");
      var v = {
        entry_pagina: location.pathname.slice(0, 300),
        verwijzer: verwijzer.slice(0, 120),
        campagne: bron || camp ? [bron, camp].filter(Boolean).join(" / ").slice(0, 200) : null,
      };
      sessionStorage.setItem(HOK, JSON.stringify(v));
      return v;
    } catch (e) {
      return { entry_pagina: location.pathname.slice(0, 300), verwijzer: "onbekend", campagne: null };
    }
  }

  function tel(soort) {
    // Twee keer op dezelfde knop binnen 30 seconden is één contactintentie.
    var merk = "l3_klik:" + soort + ":" + location.pathname;
    try {
      var vorige = Number(sessionStorage.getItem(merk) || 0);
      if (Date.now() - vorige < 30000) return;
      sessionStorage.setItem(merk, String(Date.now()));
    } catch (e) {}
    var hk = herkomst();
    try {
      fetch(REST, {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/json", apikey: KEY, Authorization: "Bearer " + KEY, Prefer: "return=minimal" },
        body: JSON.stringify({ bedrijf_id: BEDRIJF, soort: soort, pagina: location.pathname.slice(0, 300), entry_pagina: hk.entry_pagina, verwijzer: hk.verwijzer, campagne: hk.campagne }),
      }).catch(function () {});
    } catch (e) {}
  }

  herkomst(); // vastleggen bij binnenkomst, niet pas bij de klik

  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a) return;
    var href = a.getAttribute("href") || "";
    if (href.indexOf("tel:") === 0) tel("bellen");
    else if (href.indexOf("mailto:") === 0) tel("email");
    else if (href.indexOf("wa.me") !== -1 || href.indexOf("api.whatsapp.com") !== -1) tel("whatsapp");
  }, true);

  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    if (f.querySelector('input[type="email"], input[type="tel"], input[name*="mail" i], input[name*="tel" i], input[name*="phone" i]')) tel("formulier");
  }, true);
})();
